import _ from "lodash";
import React, { useEffect, useState } from "react";

import { useRootStore } from "store";
import OverlayLoader from "components/loader/OverlayLoader";
import { Entry } from "models/inventory/inventory";
import InventoryList from "../components/inventoryList/InventoryList";
import InventoryTable from "../components/inventoryTable/InventoryTable";

export default function InventoryExternalUser() {
  const {
    global,
    user,
    inventory: inventoryState
  } = useRootStore((store) => store);

  const {
    articleRegister,
    inventory,
    isCreatingInventoryPdf,
    isLoadingArticleRegister,
    isLoadingInventories,
    isLoadingInventory,
    isSavingInventory,
    isUpdatingInventory,
    clearInventory,
    getArticleRegister,
    getInventories,
    updateInventory,
    createInventoryPdf,
    getInventory
  } = inventoryState;

  const { customerName } = useRootStore(
    (state) => state.customers.workingCustomer
  );

  const username = `${user.userInfo?.givenName} ${user.userInfo?.surName}`;
  const isInventoryEmpty = _.isEmpty(inventory);
  const isArticleRegisterEmpty = _.isEmpty(articleRegister);

  const [selectedInventory, setSelectedInventory] = useState(0);

  useEffect(() => {
    clearInventory();
    if (_.isEmpty(articleRegister)) {
      getArticleRegister();
    }
    getInventories(global.workingCustomerId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGoBack = () => {
    setSelectedInventory(0);
    clearInventory();
    getInventories(global.workingCustomerId);
  };

  const handleInventoryComplete = (inventoryEntries: Entry[]) => {
    updateInventory(
      global.workingCustomerId,
      selectedInventory,
      inventoryEntries,
      "completed"
    );
  };

  const handleInventoryCreatePdf = (inventoryId: number) => {
    createInventoryPdf(
      global.workingCustomerId,
      inventoryId,
      customerName,
      username
    );
  };

  const handleInventoryOpen = (
    inventoryId: number,
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault();
    setSelectedInventory(inventoryId);
    getInventory(global.workingCustomerId, inventoryId);
  };

  const handleInventorySave = (inventoryEntries: Entry[]) => {
    updateInventory(
      global.workingCustomerId,
      selectedInventory,
      inventoryEntries,
      "ongoing"
    );
  };

  return (
    <div>
      <OverlayLoader
        isLoading={
          isLoadingArticleRegister ||
          isCreatingInventoryPdf ||
          isLoadingInventories ||
          isLoadingInventory ||
          isSavingInventory ||
          isUpdatingInventory
        }
      >
        <>
          {isInventoryEmpty && (
            <InventoryList
              onInventoryCreatePdf={handleInventoryCreatePdf}
              onInventoryOpen={handleInventoryOpen}
            />
          )}

          {!isInventoryEmpty && !isArticleRegisterEmpty && (
            <InventoryTable
              isInternalUser={false}
              onGoBack={handleGoBack}
              onInventoryComplete={handleInventoryComplete}
              onInventorySave={handleInventorySave}
            />
          )}

          {!isInventoryEmpty && isArticleRegisterEmpty && (
            <p>Inladdning av artiklar misslyckades. Pröva igen senare.</p>
          )}
        </>
      </OverlayLoader>
    </div>
  );
}
